import Backbone from 'backbone';

export default Backbone.Model.extend({

    defaults: {
        installmentCalculations: {}
    },

    /**
     * @param {int} iNUmberOfRates
     */
    load: function (iNUmberOfRates) {
        this.set(this.get('installmentCalculations')[iNUmberOfRates]);
    }

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/checkout/paymentInstallmentModel.js
 **/